<script>
	// "응답" 탭 — V3 입력폼(form) 응답 대시보드.
	// 실제 렌더/집계는 공유 컴포넌트 CollectionDashboard(source="chat")에 위임한다.
	// (봇 "수집"과 UI·로직을 하나로 통합 → 유지보수 지점 1곳. 이 파일은 chat 모델 ↔ 공유 컴포넌트 어댑터.)
	// 바라보는 테이블은 그대로: /api/Chat/getBlockList + /api/Chat/getFormSubmissions.
	// embedded=탭 헤더(currentTabLabel "응답")와 제목 중복 방지로 내부 h3 숨김.
	import CollectionDashboard from "../insights/CollectionDashboard.svelte";

	export let chat;
	const tab = "submissions";
</script>

{#if chat.isCurrentTab(tab)}
	<CollectionDashboard source="chat" chatId={chat.chatId} active={chat.chatVersion === "V3"} embedded />
{/if}
